import { render, staticRenderFns } from "./AccountCertificateFormInfo.vue?vue&type=template&id=52670aa7&scoped=true&"
import script from "./AccountCertificateFormInfo.vue?vue&type=script&lang=ts&"
export * from "./AccountCertificateFormInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AccountCertificateFormInfo.vue?vue&type=style&index=0&id=52670aa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52670aa7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
